import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import queryString from 'query-string';
import zh_tw from './zh_tw.json';
import jp from './jp.json';

const queryStringObj = queryString.parse(window.location.search);
const language = queryStringObj.language || window.localStorage.getItem('language') || undefined;
window.localStorage.setItem('language', language || '');
window.language = language;

i18n.use(initReactI18next).init({
  resources: {
    zh_tw: {
      translation: zh_tw,
    },
    jp: {
      translation: jp,
    },
  },
  fallbackLng: 'zh_tw',
  lng: language,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
